export default class CopyLink {
  constructor() {
    this.links = document.querySelectorAll(".js-copy-link");
  }

  init() {
    this.events();
  }

  events() {
    this.links.forEach(el => {
      el.addEventListener("click", this.copyLink);
    });
  }

  copyLink(e) {
    e.preventDefault();
    navigator.clipboard
      .writeText(e.target.parentElement.getAttribute("href"))
      .then(
        () => {
          /* clipboard successfully set */
        },
        () => {
          /* clipboard write failed */
        }
      );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/copyLink.js